import BaseCommand from "@/models/api/commands/BaseCommand";

export class DeleteOwnerCommand extends BaseCommand {
  CommandName = "DeleteOwner";
  Command: number;
  constructor(sessionId: string, operationId: string, cashierId: number) {
    super(sessionId, operationId);
    this.Command = cashierId;
  }
}
